export default __webpack_public_path__ + "static/media/gnl3.aa10a0da.jpg";